module.exports = __webpack_public_path__ + "img/outdoor2.552a27a6.jpg";